<template>
    <div class="form-group row" :class="error != null ? 'has-danger' : ''">
        <label class="form-control-label col-md-3 col-xl-2 col-sm-12 col-form-label">{{ labelText }}</label>
        <div class="col-md-9 col-xl-10 col-sm-12">
            <div class="dual-select-wrapper" :class="{ 'disabled': disabled }">
                <rea-loader class="loader" :loading="loading || retrieveLoading"/>
                <div v-show="!loading && !retrieveLoading">
                    <select
                        ref="select"
                        multiple
                        @change="selectChanged"
                        :required="required"
                        :disabled="disabled"
                        autocomplete="off"
                    >
                        <option
                            v-for="option in computedOptions"
                            :value="option.value"
                            :selected="option.selected"
                            :disabled="option.disabled"
                        >
                            {{ option.label }}
                        </option>
                    </select>
                    <span
                        class="help-block form-control-feedback"
                        :class=""
                        v-if="error != null"
                        v-text="error"
                    ></span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Multi from '~/vendor/multi.js';
    import { ReaLoader } from '~/components/helpers';
    import RetrieveMixin from '~/mixins/retrieve';

    export default {
        name: 'DualSelect',

        mixins: [
            RetrieveMixin,
        ],

        components: {
            ReaLoader,
        },

        props: {
            availableTitle: {
                type: String,
                required: false,
                default: 'app.available',
            },
            selectedTitle: {
                type: String,
                required: false,
                default: 'app.selected',
            },
            inputLabel: {
                type: String,
                required: false,
                default: '',
            },
            options: {
                type: Array,
                default: () => [],
            },
            search: {
                type: Boolean,
                default: false,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            required: {
                type: Boolean,
                default: false,
            },
            error: {
                type: String,
                default: null,
            },
            loading: {
                type: Boolean,
                default: false,
            },
            // Key that will be used in the retrieved data to display as the option label
            labelKey: {
                type: String,
                default: 'full_name',
            },
            value: {
                type: Array,
                default: [],
            },
        },

        data() {
            return {
                multiSelect: null,
                retrieveLoading: true,
                retrievedOptions: () => [],
            }
        },

        computed: {
            computedOptions() {
                let cOptions = this.route ? this.retrievedOptions : this.options;

                if (!this.route) {
                    cOptions = _.map(cOptions, (item, key) => {
                        // Add support for string and integer values
                        let selected = Array.isArray(this.value) ?
                            this.value.includes(item.id.toString()) || this.value.includes(parseInt(item.id)) :
                            false;

                        return {
                            id: key,
                            value: parseInt(item.id),
                            label: item[this.labelKey],
                            selected: selected
                        };
                    })
                }

                if (!cOptions || cOptions.length === 0) {
                    return [{
                        id: null,
                        value: '',
                        label: uLang('app.no_matching_records'),
                        disabled: true
                    }]
                }

                return cOptions
            },
            labelText: function () {
                return this.uLang(this.inputLabel) + (this.required ? ': *' : ': ');
            }
        },

        methods: {
            selectChanged() {
                this.$emit('input', this.getSelectValue())
            },

            getSelectValue() {
                let result = [];
                let options = this.$refs.select.options;
                let opt;

                for (let i = 0, len = options.length; i < len; i++) {
                    opt = options[i];

                    if (opt.selected) {
                        result.push(opt.value)
                    }
                }

                return result
            },

            createMultiSelect() {
                this.$nextTick(() => {
                    if (this.multiSelect) {
                        this.multiSelect.triggerRefresh();
                        return;
                    }

                    this.multiSelect = new Multi(this.$refs.select, {
                        'enable_search': this.search,
                        'search_placeholder': uLang('app.search'),
                        'non_selected_header': this.uLang(this.availableTitle),
                        'selected_header': this.uLang(this.selectedTitle),
                    });
                })
            }
        },

        watch: {
            computedOptions: {
                immediate: true,
                handler: function () {
                    this.createMultiSelect();
                }
            }
        },

        mounted() {
            if (!this.route) {
                this.retrieveLoading = false
            }

            this.$on('afterRetrieve', (result) => {
                this.retrievedOptions = _.map(result, (item, key) => {
                    let object = {
                        id: key,
                        value: isNaN(item.id) ? item.id : parseInt(item.id),
                        label: item[this.labelKey],
                        disabled: item.disabled,
                    };

                    // Add selected if the id is also in the values array
                    if (!_.isEmpty(this.value)
                        && _.findIndex(this.value, (valueItem) => {
                            return valueItem.id == item.id
                        }) > -1) {
                        object.selected = true
                    }

                    return object;
                });
                this.createMultiSelect();
                this.$nextTick(() => {
                    this.$emit('input', this.getSelectValue())
                });
                this.retrieveLoading = false
            });
        },
    }
</script>
<style>
    .multi-wrapper {
        width: auto;
        border: 0;
        border-radius: 0;
    }

    .dual-select-wrapper .loader {
        min-height: 35px;
        display: block;
    }

    .dual-select-wrapper {
        position: relative;
        box-sizing: border-box;
    }

    .dual-select-wrapper .multi-wrapper .non-selected-wrapper,
    .dual-select-wrapper .multi-wrapper .selected-wrapper {
        width: 100%;
        background-color: #ffffff;
        border: 1px solid #f2f2f2;
        padding: 0;
        height: 100%;
        overflow-y: unset;
    }

    .non-selected-wrapper .search-holder {
        position: relative;
        height: 40px;
    }

    .non-selected-wrapper .search-holder .search-input {
        background-color: #f2f2f2;
        border-bottom: none;
        padding-left: 35px;
    }

    .non-selected-wrapper .search-holder .search-input::placeholder,
    .non-selected-wrapper .search-holder::before {
        color: #a0a0a0;
    }

    .non-selected-wrapper .search-holder::before {
        content: "\f002";
        font-family: FontAwesome;
        left: 15px;
        position: absolute;
        top: 9px;
    }

    .dual-select-wrapper .multi-wrapper .non-selected-wrapper .header,
    .dual-select-wrapper .multi-wrapper .selected-wrapper .header {
        font-weight: 500;
    }

    .dual-select-wrapper.disabled .multi-wrapper .non-selected-wrapper,
    .dual-select-wrapper.disabled .multi-wrapper .selected-wrapper {
        background-color: #f2f2f2;
    }

    .dual-select-wrapper.disabled .multi-wrapper .header {
        border-color: #f2f2f2;
    }

    .multi-wrapper .header {
        margin: 0;
        padding: 8px 15px;
        background-color: #f2f2f2;
        font-weight: 500;
    }

    .multi-wrapper .inner {
        border-top: 1px solid #fff;
        max-height: 160px;
        overflow-y: auto;
    }

    .multi-wrapper .selected-wrapper .inner {
        max-height: 200px;
    }

    .multi-wrapper .item {
        padding: 8px 15px;
        color: #292b2c;
        border-bottom: 1px solid #f2f2f2;
        max-height: 180px;
        overflow-y: auto;
    }

    .multi-wrapper .item:hover {
        background-color: #f2f2f2;
        border-radius: 2px;
        border-color: #f2f2f2;
    }
</style>
